import { render, staticRenderFns } from "./presentacion.vue?vue&type=template&id=21cd8b7b&scoped=true&"
import script from "./presentacion.vue?vue&type=script&lang=js&"
export * from "./presentacion.vue?vue&type=script&lang=js&"
import style0 from "./presentacion.vue?vue&type=style&index=0&id=21cd8b7b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21cd8b7b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!F:/Backup_Juan/ecopetrol/Cursos 2019/hidrocarburos/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib'
installComponents(component, {VFlex})
